<template>
    <div class="search_customer">
        <LoaderAnimation v-if="ajaxLoading"></LoaderAnimation>
        <!-- 
      <pre>prop: isMainBooker:{{isMainBooker}}</pre>    
      <pre>prop: isInsert:{{isInsert}}</pre>
      <pre>{{customerData}}</pre>    

      <pre>enterDetails:{{enterDetails}}</pre>    
      <pre>showSearch:{{showSearch}}</pre>    
      <pre>disableImportantDataChanges:{{disableImportantDataChanges}}</pre>     -->
        <slot />
        <div v-if="showSearch && isInsert && isMainBooker" id="otp_area">
            <h4 v-if="knownCustomer">
                {{ $t("We think you've booked with us before.") }}
            </h4>
            <h4 v-else>{{ $t("Have you booked with us before?") }}</h4>
            <p>
                {{ $t("We can email you a code to load your saved details.") }}
            </p>
            <template v-if="!codeSent">
                <div id="otp_request">
                    <div class="col-sm-6 div2020">
                        <label for="otp_email">{{ $t("Email address") }}</label>
                        <input
                            v-model="otpEmail"
                            type="text"
                            id="otp_email"
                            class="inputbtn btndefault btnblock"
                        />
                    </div>
                    <div class="col-sm-6 div2020">
                        <label style="display:block; opacity:0">{{
                            $t("Email me a code")
                        }}</label>
                        <button
                            @click.prevent="sendOtpCode"
                            :disabled="!canSendCode"
                            class="button blue"
                            id="otp_send"
                        >
                            {{ $t("Email me a code") }}
                        </button>
                    </div>
                </div>
            </template>
            <template v-else>
                <div id="otp_entry">
                    <div class="col-sm-6 div2020">
                        <label for="otp_code">{{
                            $t("Enter the code we emailed you")
                        }}</label>
                        <input
                            v-model="otpCode"
                            v-maska="'######'"
                            type="text"
                            id="otp_code"
                            class="inputbtn btndefault btnblock"
                        />
                    </div>
                    <div class="col-sm-6 div2020">
                        <label style="display:block; opacity:0">{{
                            $t("Verify code")
                        }}</label>
                        <button
                            @click.prevent="verifyOtpCode"
                            :disabled="otpCode.length != 6"
                            class="button blue"
                            id="otp_verify"
                        >
                            {{ $t("Verify code") }}
                        </button>
                        &nbsp;
                        <button
                            @click.prevent="sendOtpCode"
                            class="button"
                            id="otp_resend"
                        >
                            {{ $t("Resend code") }}
                        </button>
                    </div>
                </div>
            </template>
            <p v-if="otpError" id="otp_error" style="color:#c00">
                {{ otpError }}
            </p>
            <p
                v-if="devCodeHint"
                id="otp_devcode"
                style="color:#888;font-family:monospace"
            >
                DEV code (no email sent): {{ devCodeHint }}
            </p>
            <p>
                <em>{{ $t("Or fill in the form below.") }}</em>
            </p>
            <hr />
        </div>
        <div v-if="showSearch && isInsert">
            <p>
                {{
                    $t(
                        "Please ensure you use capital letters in the right places"
                    )
                }}
            </p>

            <div id="search_contact">
                <div class="col-sm-6 div2020">
                    <label for="search_name"
                        >{{ $t("Name") }}<br /><em>
                            {{ $t("(as shown on your passport)") }}</em
                        ></label
                    >
                    <input
                        v-model="searchName"
                        type="text"
                        id="search_name"
                        class="inputbtn btndefault btnblock"
                    />
                </div>
                <div class="col-sm-6 div2020">
                    <label for="search_lastname"
                        >{{ $t("Last name") }}<br /><em>{{
                            $t("(as shown on your passport)")
                        }}</em></label
                    >
                    <input
                        v-model="searchLastName"
                        type="text"
                        id="search_lastname"
                        class="inputbtn btndefault btnblock"
                    />
                </div>
                <div class="col-sm-6 div2020">
                    <label for="search_dob"
                        >{{ $t("Date of birth") }} (dd/mm/yyyy)</label
                    >
                    <input
                        v-model="searchDOB"
                        v-maska="'##/##/####'"
                        type="text"
                        id="search_dob"
                        class="inputbtn btndefault btnblock"
                    />
                </div>
                <div class="col-sm-6 div2020">
                    <label for="search_postcode">{{ $t("Postcode") }}</label>
                    <input
                        v-model="searchPostcode"
                        type="text"
                        id="search_postcode"
                        class="inputbtn btndefault btnblock"
                    />
                </div>
            </div>

            <div class="col-sm-6 div2020">
                <button
                    @click.prevent="searchCustomer"
                    :disabled="!canSearch"
                    href="#"
                    class="button blue"
                    id="post_search"
                >
                    {{ $t("Search") }}
                </button>
                &nbsp;
                <button
                    @click.prevent="neverBeenBefore"
                    href="#"
                    class="button blue"
                    id="never_been"
                >
                    {{ $t("Never been before") }}
                </button>
                &nbsp;
                <button
                    v-if="canCancel"
                    @click.prevent="cancelForm"
                    href="#"
                    class="button"
                    id="cancel_search"
                >
                    {{ $t("Cancel") }}
                </button>
            </div>
            <p>
                {{
                    $t(
                        '​If the information above is on our database, we will retrieve your record. If you’re not an existing customer, please click "Never been before". If your address has changed, please use your old postcode and then update your details on the next page.'
                    )
                }}
            </p>
        </div>

        <div v-if="enterDetails || !isInsert" class="customerDetails">
            <div class="div2020">
                <label for="CustomerName"
                    >{{ $t("Name") }}
                    <RequiredMark :isValid="isNameValid" /><br /><em>{{
                        $t("(as shown on your passport)")
                    }}</em></label
                >
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerName"
                    :disabled="disableImportantDataChanges"
                    v-model="customerData.Name"
                />
            </div>

            <div class="div2020">
                <label for="CustomerLastName"
                    >{{ $t("Last name") }}
                    <RequiredMark :isValid="isLastNameValid" /><br /><em>{{
                        $t("(as shown on your passport)")
                    }}</em></label
                >
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerLastName"
                    :disabled="disableImportantDataChanges"
                    v-model="customerData.LastName"
                />
            </div>

            <div class="div2020">
                <label for="CustomerDOB"
                    >{{ $t("Date of birth") }} (dd/mm/yyyy)<RequiredMark
                        :isValid="isDOBValid"
                /></label>
                <input
                    type="text"
                    v-maska="'##/##/####'"
                    class="inputbtn btndefault btnblock"
                    id="CustomerDOB"
                    :disabled="disableImportantDataChanges"
                    v-model="customerData.DOB"
                />
            </div>

            <div class="div2020">
                <label for="CustomerGender">{{ $t("Gender") }}</label>
                <select
                    v-model="customerData.gender"
                    :disabled="disableImportantDataChanges"
                    class="inputbtn btndefault btnblock"
                    id="CustomerGender"
                >
                    <option value=""></option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                </select>
            </div>

            <div class="div2020">
                <label for="CustomerPostcode">{{ $t("Postcode") }}</label>
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerPostcode"
                    v-model="customerData.Postcode"
                />
            </div>

            <div class="input padd div2020">
                <label for="CustomerPostcode" style="opacity:0"
                    >dummy label</label
                >
                <a
                    @click.prevent="findPostcode"
                    style="width: 90%;"
                    class="button blue"
                    href="#"
                    >{{ codeplusButtonTitle }}</a
                >
            </div>
            <div v-if="codeplusList.length" id="codeplus-area">
                <h4>{{ $t("Select your address from the list") }}:</h4>
                <ul id="codeplus-items">
                    <li
                        v-for="item in codeplusList"
                        :key="item['@attributes'].value"
                    >
                        <a href="#" @click.prevent="getAddress(item.PostKey)">
                            {{ item.Address }}
                        </a>
                    </li>
                </ul>
            </div>

            <div class="div2020">
                <label for="CustomerHouse">{{ $t("House") }}</label>
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerHouse"
                    v-model="customerData.House"
                />
            </div>

            <div class="div2020">
                <label for="CustomerStreet"
                    >{{ $t("Street")
                    }}<RequiredMark
                        :isValid="isStreetValid"
                        :isRequired="isMainBooker"
                /></label>
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerStreet"
                    v-model="customerData.Street"
                />
            </div>

            <div class="div2020">
                <label for="CustomerTown"
                    >{{ $t("Town")
                    }}<RequiredMark
                        :isValid="isTownValid"
                        :isRequired="isMainBooker"
                /></label>
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerTown"
                    v-model="customerData.Town"
                />
            </div>

            <div class="div2020">
                <label for="CustomerLocality">{{ $t("Locality") }}</label>
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerLocality"
                    v-model="customerData.Locality"
                />
            </div>

            <div class="div2020">
                <label for="CustomerCounty">{{ $t("County") }}</label>
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerCounty"
                    v-model="customerData.County"
                />
            </div>

            <div class="div2020">
                <label for="CustomerPassportCountry"
                    >{{ $t("Passport Country")
                    }}<RequiredMark :isValid="isPassportCountryValid"
                /></label>
                <select
                    v-model="customerData.PassportCountry"
                    class="inputbtn btndefault btnblock"
                    id="CustomerPassportCountry"
                >
                    <option
                        v-for="(country, index) in getLoadedCountries"
                        :value="country"
                        :key="index"
                        >{{ country }}</option
                    >
                </select>
            </div>

            <div class="div2020">
                <label for="CustomerCountry">{{ $t("Country") }}</label>
                <select
                    v-model="customerData.Country"
                    class="inputbtn btndefault btnblock"
                    id="CustomerCountry"
                >
                    <option
                        v-for="(country, index) in getLoadedCountries"
                        :value="country"
                        :key="index"
                        >{{ country }}</option
                    >
                </select>
            </div>

            <div class="div2020">
                <label for="CustomerEMail"
                    >{{ $t("Email")
                    }}<RequiredMark
                        :isValid="isEMailValid"
                        :isRequired="isMainBooker"
                /></label>
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerEMail"
                    v-model="customerData.EMail"
                />
            </div>

            <div class="div2020">
                <label for="CustomerPhoneMob"
                    >{{ $t("Mobile phone")
                    }}<RequiredMark
                        :isValid="isPhoneValid"
                        :isRequired="isMainBooker"
                /></label>
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerPhoneMob"
                    v-model="customerData.PhoneMob"
                />
            </div>

            <div class="div2020">
                <label for="CustomerPhone">{{ $t("Phone") }}</label>
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerPhone"
                    v-model="customerData.Phone"
                />
            </div>

            <div class="div2020">
                <label for="CustomerPhoneWork">{{ $t("Work Phone") }}</label>
                <input
                    type="text"
                    class="inputbtn btndefault btnblock"
                    id="CustomerPhoneWork"
                    v-model="customerData.PhoneWork"
                />
            </div>

            <div class="div2020" style="text-align:right">
                <label style="display:block; opacity:0">{{
                    $t("Continue")
                }}</label>
                <button
                    v-if="canCancel"
                    @click.prevent="cancelForm"
                    class="button"
                    id="cancel_details"
                >
                    {{ $t("Cancel") }}
                </button>
                &nbsp;
                <button
                    :disabled="!isValidated"
                    @click.prevent="saveData"
                    class="button blue"
                >
                    {{ $t("Continue") }} &gt;&gt;
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import { maska } from "maska";

export default {
    directives: { maska },
    data() {
        return {
            ajaxLoading: false,

            searchName: "",
            searchLastName: "",
            searchDOB: "",
            searchPostcode: "",

            enterDetails: false,
            showSearch: true,

            otpEmail: "",
            otpCode: "",
            codeSent: false,
            knownCustomer: false,
            otpError: "",
            devCodeHint: "",

            // disableImportantDataChanges: false,
            titleIds: {
                "1": "Mr",
                "2": "Mrs",
                "3": "Miss",
                "5": "Rev",
                "6": "Dr",
                "7": "Ms",
                "8": "Sir",
                "9": "Rev Dr",
                "10": "Lady",
                "11": "Prof",
                "12": "Mme",
                "13": "M",
                "17": "Mlle",
                "19": "Major"
            },
            codeplusList: [],
            codePlusFound: false,

            errors: [],

            customerData: {
                Id: null,
                TitleID: "",
                gender: "",
                Name: "",
                LastName: "",
                DOB: "",
                Postcode: "",
                House: "",
                Street: "",
                Town: "",
                Locality: "",
                County: "",
                Country: "",
                PassportCountry: "",
                EMail: "",
                Phone: "",
                PhoneWork: "",
                PhoneMob: ""
            }
        };
    },
    props: {
        customer: {
            type: Object,
            default: {}
        },
        isMainBooker: {
            type: Boolean,
            default: true
        },
        isInsert: {
            type: Boolean,
            default: true
        },
        canCancel: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        uk2ISO(d) {
            return (
                d.split("/")[2] + "-" + d.split("/")[1] + "-" + d.split("/")[0]
            );
        },
        ISO2Uk(d) {
            return (
                d.split("-")[2] + "/" + d.split("-")[1] + "/" + d.split("-")[0]
            );
        },
        resetFields() {
            this.customerData.Id = "";
            this.customerData.TitleID = "";
            this.customerData.Name = "";
            this.customerData.LastName = "";
            this.customerData.DOB = "";
            this.customerData.Postcode = "";
            this.customerData.House = "";
            this.customerData.Street = "";
            this.customerData.Town = "";
            this.customerData.Locality = "";
            this.customerData.County = "";
            this.customerData.Country = "";
            this.customerData.PassportCountry = "";
            this.customerData.EMail = "";
            this.customerData.Phone = "";
            this.customerData.PhoneWork = "";
            this.customerData.gender = "";
            this.customerData.PhoneMob = "";
        },
        fillCustomerData(customer) {
            this.customerData.Id = customer.Id;
            this.customerData.TitleID = customer.TitleID || "";
            this.customerData.Name = customer.Name || "";
            this.customerData.LastName = customer.LastName || "";
            this.customerData.DOB = customer.DOB
                ? this.ISO2Uk(customer.DOB)
                : "";
            this.customerData.Postcode = customer.Postcode || "";
            this.customerData.House = customer.House || "";
            this.customerData.Street = customer.Street || "";
            this.customerData.Town = customer.Town || "";
            this.customerData.Locality = customer.Locality || "";
            this.customerData.County = customer.County || "";
            this.customerData.Country = customer.Country || "";
            this.customerData.PassportCountry = customer.PassportCountry || "";
            this.customerData.EMail = customer.EMail || "";
            this.customerData.gender = customer.gender || "";
            this.customerData.Phone = customer.Phone || "";
            this.customerData.PhoneWork = customer.PhoneWork || "";
            this.customerData.PhoneMob = customer.PhoneMob || "";
            this.customerData.EnqSourceID = customer.EnqSourceID || null;

            if (
                this.customerData.PassportCountry &&
                this.getLoadedCountries.indexOf(
                    this.customerData.PassportCountry
                ) == -1
            ) {
                let newArr = this.getLoadedCountries;
                newArr.push(this.customerData.PassportCountry);
                this.$store.commit("UPDATE_COUNTRIES", newArr);
            }
            if (
                this.customerData.Country &&
                this.getLoadedCountries.indexOf(this.customerData.Country) == -1
            ) {
                let newArr = this.getLoadedCountries;
                newArr.push(this.customerData.Country);
                this.$store.commit("UPDATE_COUNTRIES", newArr);
            }
        },
        checkOtpEmail() {
            if (!this.otpEmail) return;
            axios
                .post(process.env.VUE_APP_ROOT_URL + "customers/check-email", {
                    email: this.otpEmail
                })
                .then(response => {
                    this.knownCustomer = !!response.data.exists;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        sendOtpCode() {
            this.otpError = "";
            this.ajaxLoading = true;
            axios
                .post(process.env.VUE_APP_ROOT_URL + "customers/send-code", {
                    email: this.otpEmail,
                    bid: this.getBookingDetails.bookingId,
                    lang: this.$i18n.locale || "en"
                })
                .then(response => {
                    this.ajaxLoading = false;
                    if (response.data.sent) {
                        this.codeSent = true;
                        this.otpCode = "";
                        if (response.data.devCode) {
                            // DEV mode only: the backend returns the code
                            // instead of emailing it, so testing never
                            // sends real email; shown on the page too
                            console.log("OTP devCode:", response.data.devCode);
                            this.devCodeHint = response.data.devCode;
                        }
                    } else if (response.data.error == "rate_limited") {
                        this.otpError = this.$t(
                            "Too many codes requested. Please try again later or fill in the form below."
                        );
                    } else {
                        this.otpError = this.$t(
                            "Please enter a valid email address."
                        );
                    }
                })
                .catch(e => {
                    console.log(e);
                    this.ajaxLoading = false;
                });
        },
        verifyOtpCode() {
            this.otpError = "";
            this.ajaxLoading = true;
            axios
                .post(process.env.VUE_APP_ROOT_URL + "customers/verify-code", {
                    email: this.otpEmail,
                    code: this.otpCode,
                    bid: this.getBookingDetails.bookingId
                })
                .then(response => {
                    this.ajaxLoading = false;
                    if (response.data.verified) {
                        this.$store.commit(
                            "UPDATE_SUGGESTED_COMPANIONS",
                            response.data.companions || []
                        );
                        if (response.data.customer) {
                            this.fillCustomerData(response.data.customer);
                        } else {
                            this.resetFields();
                            this.customerData.EMail = this.otpEmail;
                        }
                        this.showSearch = false;
                        this.enterDetails = true;
                        this.$swal(
                            "",
                            this.$t(
                                "Your details have been loaded. Please check they are correct and complete, then click 'Continue'."
                            ),
                            "success"
                        );
                    } else if (response.data.error == "wrong_code") {
                        this.otpError = this.$t(
                            "That code is not right, please try again."
                        );
                    } else if (response.data.error == "too_many_attempts") {
                        this.codeSent = false;
                        this.otpError = this.$t(
                            "Too many attempts. Please request a new code."
                        );
                    } else {
                        this.codeSent = false;
                        this.otpError = this.$t(
                            "That code has expired or was already used. Please request a new one."
                        );
                    }
                })
                .catch(e => {
                    console.log(e);
                    this.ajaxLoading = false;
                });
        },
        searchCustomer() {
            // console.log('searchCustomer');
            this.ajaxLoading = true;
            axios
                .post(process.env.VUE_APP_ROOT_URL + `customers/search`, {
                    name: this.searchName,
                    lastname: this.searchLastName,
                    // dob: this.searchDOB,
                    dob: this.searchDobISO,
                    postcode: this.searchPostcode
                })
                .then(response => {
                    this.ajaxLoading = false;
                    // JSON responses are automatically parsed.
                    if (response.data.response.result) {
                        console.log(response.data.response.customer);
                        this.customerData.Id =
                            response.data.response.customer.Id;
                        this.customerData.TitleID =
                            response.data.response.customer.TitleID;
                        this.customerData.Name =
                            response.data.response.customer.Name;
                        this.customerData.LastName =
                            response.data.response.customer.LastName;
                        this.customerData.DOB = this.ISO2Uk(
                            response.data.response.customer.DOB
                        );
                        this.customerData.Postcode =
                            response.data.response.customer.Postcode;
                        this.customerData.House =
                            response.data.response.customer.House;
                        this.customerData.Street =
                            response.data.response.customer.Street;
                        this.customerData.Town =
                            response.data.response.customer.Town;
                        this.customerData.Locality =
                            response.data.response.customer.Locality;
                        this.customerData.County =
                            response.data.response.customer.County;
                        this.customerData.Country =
                            response.data.response.customer.Country;
                        this.customerData.PassportCountry =
                            response.data.response.customer.PassportCountry;
                        this.customerData.EMail =
                            response.data.response.customer.EMail;
                        this.customerData.gender =
                            response.data.response.customer.gender;
                        this.customerData.Phone =
                            response.data.response.customer.Phone;
                        this.customerData.PhoneWork =
                            response.data.response.customer.PhoneWork;
                        this.customerData.PhoneMob =
                            response.data.response.customer.PhoneMob;
                        this.customerData.EnqSourceID =
                            response.data.response.customer.EnqSourceID;

                        if (
                            this.getLoadedCountries.indexOf(
                                this.customerData.PassportCountry
                            ) == -1
                        ) {
                            let newArr = this.getLoadedCountries;
                            newArr.push(this.customerData.PassportCountry);
                            this.$store.commit("UPDATE_COUNTRIES", newArr);
                        }
                        if (
                            this.getLoadedCountries.indexOf(
                                this.customerData.Country
                            ) == -1
                        ) {
                            let newArr = this.getLoadedCountries;
                            newArr.push(this.customerData.Country);
                            this.$store.commit("UPDATE_COUNTRIES", newArr);
                        }

                        this.showSearch = false;
                        this.enterDetails = true;

                        // this.disableImportantDataChanges=true;

                        // console.log(this.$t("Continue"));

                        this.$swal(
                            "",
                            this.$t(
                                "Please check these details are correct and complete, then click 'Continue'."
                            ),
                            "success"
                        );
                    } else {
                        this.resetFields();
                        this.$swal(
                            "",
                            this.$t(
                                "No matches found. Please check your details again or click 'Never been before' button"
                            ),
                            "warning"
                        );
                    }
                })
                .catch(e => {
                    // this.errors.push(e)
                    console.log(e);
                    this.ajaxLoading = false;
                });
        },
        neverBeenBefore() {
            this.resetFields();
            this.enterDetails = true;
            this.showSearch = false;
            this.customerData.Name = this.searchName;
            this.customerData.LastName = this.searchLastName;
            this.customerData.Postcode = this.searchPostcode;
            this.customerData.DOB = this.searchDOB;
        },
        getAddress(adrCode) {
            console.log("getAddress", adrCode);
            this.ajaxLoading = true;
            axios
                .post(
                    process.env.VUE_APP_ROOT_URL + "customers/codeplus-details",
                    {
                        addressCode: adrCode
                    }
                )
                .then(response => {
                    this.ajaxLoading = false;
                    // console.log(response.data.xml);

                    if (
                        Object.keys(response.data.xml.Address.Property)
                            .length !== 0
                    ) {
                        this.customerData.House =
                            response.data.xml.Address.Property;
                    } else {
                        this.customerData.House = "";
                    }
                    if (
                        response.data.xml.Address.Locality &&
                        Object.keys(response.data.xml.Address.Locality)
                            .length !== 0
                    ) {
                        this.customerData.Locality =
                            response.data.xml.Address.Locality;
                    } else {
                        this.customerData.Locality = "";
                    }

                    if (
                        response.data.xml.Address.County &&
                        Object.keys(response.data.xml.Address.County).length !==
                            0
                    ) {
                        this.customerData.County =
                            response.data.xml.Address.County;
                    } else {
                        this.customerData.County = "";
                    }

                    if (
                        response.data.xml.Address.DPS &&
                        Object.keys(response.data.xml.Address.DPS).length !== 0
                    ) {
                        this.customerData.DPS = response.data.xml.Address.DPS;
                    } else {
                        this.customerData.DPS = "";
                    }

                    this.customerData.Street = response.data.xml.Address.Street;
                    this.customerData.Town = response.data.xml.Address.Town;
                    this.customerData.Country = "United Kingdom";
                    this.customerData.PassportCountry = "United Kingdom";
                    this.codeplusList = [];
                    this.codePlusFound = true;
                })
                .catch(e => {
                    // this.errors.push(e)
                    console.log(e);
                    this.ajaxLoading = false;
                });
        },
        findPostcode() {
            this.ajaxLoading = true;
            axios
                .post(process.env.VUE_APP_ROOT_URL + "customers/codeplus", {
                    postcode: this.customerData.Postcode
                })
                .then(response => {
                    this.ajaxLoading = false;
                    this.codeplusList = response.data.xml.AddressListItem;
                    console.log(response.data.xml.AddressListItem.length);
                    console.log(response.data.xml.AddressListItem);
                })
                .catch(e => {
                    // this.errors.push(e)
                    console.log(e);
                    this.ajaxLoading = false;
                });
        },
        saveData() {
            this.$emit("saved", this.customerData);
        },
        cancelForm() {
            this.$emit("cancelled");
        }
    },
    computed: {
        ...mapGetters(["getLoadedCountries", "getBookingDetails"]),
        canSendCode() {
            return /^\S+@\S+\.\S+$/.test(this.otpEmail.trim());
        },
        canSearch() {
            return (
                this.searchName != "" &&
                this.searchLastName != "" &&
                this.searchDOB != "" &&
                this.searchDOB.length == 10 &&
                this.searchPostcode != ""
            );
        },
        isTitleIDValid() {
            return true; //this.customerData.TitleID!='';
        },
        isNameValid() {
            return this.customerData.Name != "";
        },
        isLastNameValid() {
            return this.customerData.LastName != "";
        },
        isDOBValid() {
            return this.customerData.DOB != "";
        },
        isStreetValid() {
            return this.customerData.Street != "";
        },
        isTownValid() {
            return this.customerData.Town != "";
        },
        isPassportCountryValid() {
            return this.customerData.PassportCountry != "";
        },
        isEMailValid() {
            return this.customerData.EMail != "";
        },
        isPhoneValid() {
            return this.customerData.PhoneMob != "";
        },
        searchDobISO() {
            return this.uk2ISO(this.searchDOB);
        },
        dobISO() {
            return this.uk2ISO(this.customerData.DOB);
        },
        isValidated() {
            return (
                this.isTitleIDValid &&
                this.isNameValid &&
                this.isLastNameValid &&
                this.isDOBValid &&
                this.isPassportCountryValid &&
                (!this.isMainBooker ||
                    (this.isStreetValid &&
                        this.isTownValid &&
                        this.isEMailValid &&
                        this.isPhoneValid))
            );
        },
        codeplusButtonTitle() {
            return this.codePlusFound
                ? this.$t("Reselect Address")
                : this.$t("Find Address");
        },
        disableImportantDataChanges() {
            return (
                typeof this.customerData.Id !== "undefined" &&
                this.customerData.Id != ""
            ); //&& (!this.isInsert)
        }
    },
    created() {
        if (process.env.VUE_APP_DEBUG == 1) {
            this.searchName = "test";
            this.searchLastName = "test";
            this.searchDOB = "11/11/1999";
            this.searchPostcode = "test";
        }
        if (!this.isInsert && this.customer) this.customerData = this.customer;

        // pre-fill from the welcome popup lead and silently check whether
        // the email is on file (drives the "we think you've booked before"
        // wording); nothing is revealed without a verified code
        if (this.isMainBooker && this.isInsert) {
            if (this.getBookingDetails.leadEmail) {
                this.otpEmail = this.getBookingDetails.leadEmail;
                this.checkOtpEmail();
            }
            if (this.getBookingDetails.leadName && this.searchName === "") {
                this.searchName = this.getBookingDetails.leadName;
            }
        }
    }
};
</script>

<style scoped>
label em {
    font-size: 80%;
    font-weight: normal;
}
#codeplus-area {
    width: 100%;
    background-color: rgb(246, 224, 140);
    padding: 3px 15px;
}
</style>
